import { Link, useNavigate } from "react-router-dom";
import {
  FaRss,
  FaVimeoV,
  FaTumblr,
  FaPinterestP,
  FaLinkedinIn,
} from "react-icons/fa";
import { useStore } from "../context/Storecontext";

export default function WishlistPage() {
  const { wishlist, removeFromWishlist, addToCart } = useStore();
  const navigate = useNavigate();

  const handleAddToCart = (item) => {
    addToCart(item);
    removeFromWishlist(item.id);
    navigate("/cart");
  };

  return (
    <div>
      <div
        className="w-full h-32 bg-cover bg-center relative flex items-center p-8 border-b border-gray-100 overflow-hidden"
        style={{ backgroundImage: "url(/img/bg/banner18.jpg)" }}
      >
        <nav className="text-xs text-gray-400 font-medium tracking-wide justify-center items-center m-auto text-center">
          <h2 className="text-2xl text-black font-semibold mb-2">Wishlist</h2>
          <Link to="/" className="hover:text-[#43a047] transition-colors">
            Home
          </Link>
          <span className="mx-2 text-gray-300">/</span>
          <span className="text-gray-600">Wishlist </span>
        </nav>
      </div>

      <div className="max-w-7xl mx-auto px-4 py-10">
        {wishlist.length === 0 ? (
          <div className="text-center py-20">
            <p className="text-gray-500 mb-4">Your wishlist is empty.</p>
            <Link
              to="/products"
              className="bg-primary text-white px-6 py-2.5 text-sm hover:bg-primary-dark transition-colors"
            >
              Continue Shopping
            </Link>
          </div>
        ) : (
          <>
            <div className="overflow-x-auto border border-border-color">
              <table className="w-full text-sm">
                <thead>
                  <tr className="border-b-2 border-primary text-left text-gray-500 uppercase text-xs">
                    <th className="p-4">Delete</th>
                    <th className="p-4">Image</th>
                    <th className="p-4">Product</th>
                    <th className="p-4">Price</th>
                    <th className="p-4">Stock Status</th>
                    <th className="p-4">Add To Cart</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-border-color">
                  {wishlist.map((item) => (
                    <tr key={item.id}>
                      <td className="p-4">
                        <button
                          onClick={() => removeFromWishlist(item.id)}
                          className="text-gray-500 hover:text-red-500 font-semibold"
                        >
                          X
                        </button>
                      </td>
                      <td className="p-4">
                        <img
                          src={item.img1}
                          alt={item.name}
                          className="w-16 h-16 object-cover border border-border-color"
                        />
                      </td>
                      <td className="p-4 font-medium text-dark hover:text-primary">
                        <Link
                          to={`/product-details/${item.product_id || item.id}`}
                        >
                          {item.name}
                        </Link>
                      </td>
                      <td className="p-4 text-primary font-semibold">
                        ${item.price}.00
                      </td>
                      <td className="p-4 text-gray-500">In Stock</td>
                      <td className="p-4">
                        <button
                          onClick={() => handleAddToCart(item)}
                          className="bg-green-600 text-white text-xs font-semibold px-4 py-2 uppercase hover:bg-green-700 transition-colors"
                        >
                          Add To Cart
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            <div className="mt-10 border border-border-color py-6 text-center">
              <p className="font-semibold text-dark mb-3">Share On:</p>
              <div className="flex justify-center gap-3">
                {[FaRss, FaVimeoV, FaTumblr, FaPinterestP, FaLinkedinIn].map(
                  (Icon, i) => (
                    <a
                      key={i}
                      href="#"
                      className="w-8 h-8 border border-border-color flex items-center justify-center text-gray-400 hover:text-white hover:bg-primary hover:border-primary transition-colors"
                    >
                      <Icon size={12} />
                    </a>
                  ),
                )}
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
